<template>
  <div :class="$style.container">
    <h1 :class="$style.title">{{ title }}</h1>

    <div :class="$style.language">
      <localization-controller :language="language" />
    </div>
  </div>
</template>

<script>
import LocalizationController from 'organisms/localization/LocalizationController';

export default {
  name: 'BaseHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    language: {
      type: Object,
      required: true,
    },
  },
  components: {
    LocalizationController,
  },
};
</script>

<style lang="sass" module>
  .container
    display: flex
    justify-content: space-between

  .title
    +base-title

  .language
    padding: 0 10px
</style>
